import { checkRecaptcha, checkFields } from '~/salesforce/_validation'
import { submitForm } from '~/salesforce/_util'

export default function initSalesforce(mapConfig, map, simulate = '') {

  // Replace Kentico's submit handler with our own
  window.addEventListener('load', () => {
    const formSelector = mapConfig.formSelector[map]

    if (formSelector) {
      const subscribeForm = document.querySelector(formSelector)

      if (subscribeForm) {
        subscribeForm.setAttribute('onsubmit', 'subscribeFormSubmit(event);')
      }
    }
  })

  // Attach our submit handler function to window
  window.subscribeFormSubmit = async function (event) {
    event.preventDefault()
    event.stopPropagation()

    const form = document.querySelector(`#${event.target.id}`)
    if (!form.reportValidity()) {
      return
    }

    // If the hostname matches, or the query string ?simulate=prod is present
    // return the production map, otherwise use dev
    const hostname = window.location.hostname;
    const context = (hostname === 'scu.mb.ca' || simulate === 'prod') ? 'prod' : 'dev'

    const endpoint = mapConfig.context[context].endpoint
    const oid = mapConfig.context[context].oid

    const formInputs = {
      selectors: {
        ...mapConfig.formInputs.shared,
        ...mapConfig.formInputs[map]
      },
      selected: {}
    }

    // Collect all our fields, this would be much simpler if we could use data attributes,
    // wouldn't even need to map half of this 😡
    for (const input in formInputs.selectors) {
      const currentValue = formInputs.selectors[input]
      if (Array.isArray(currentValue)) {
        const [selector] = currentValue
        formInputs.selected[input] = [
          form.querySelector(`${selector}`),
          form.querySelectorAll(`${selector}:checked`)
        ]
      } else {
        // Select on document, because the hidden inputs are added outside of Kentico form
        formInputs.selected[input] = document.querySelector(currentValue)
      }
    }

    // Check if the input fields and the reCaptcha is valid
    const recaptchaValid = checkRecaptcha()
    const fieldsValid = checkFields(formInputs.selected, map)

    // Check if the Email address is correct before submitting
    if (recaptchaValid && fieldsValid) {
      try {
        const sf = {
          ...mapConfig.salesforceIDs.shared,
          ...mapConfig.salesforceIDs[context][map]
        }
        await submitForm(endpoint, oid, formInputs.selected, sf, map)
        window.kentico.updatableFormHelper.submitForm(event);
        // console.log('successfully submitted!')
      } catch (error) {
        console.log('error while submitting the form ' + error)
      }
    } else {
      form.reportValidity()
      return
    }
  }
}
